import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";



import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";

const LadgerDetails = () => {
    const location = useLocation();

    const memberName = location.state?.memberName || "";
    const unitNo = location.state?.unitNo || "";
    const societyName = localStorage.getItem("society");
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({});

    const [ledgerList, setLedgerList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (memberName && unitNo) {
            fetchLedgerData();
        }
    }, []);


    const handleUpdate = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.put(
                `${BASE_URL}/ledger/edit-updated-ledger`,
                null,
                {
                    params: {
                        ledgerId: editData.ledgerId,
                        ledgerDate: editData.ledgerDate,
                        particular: editData.particular,
                        vchType: editData.vchType,
                        debit: editData.debit,
                        credit: editData.credit,
                        balance: editData.balance,
                        societyName: editData.societyName,
                        flatNo: editData.flatNo,
                        memberName: editData.memberName,
                        instrument: editData.instrument,
                        instrumentNo: editData.instrumentNo,
                        numberBillOrReceipt: editData.numberBillOrReceipt,
                        advancePayment: editData.advancePayment,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            alert(response.data);
            setShowModal(false);
            fetchLedgerData();
        } catch (error) {
            console.error(error);
            alert("Update Failed");
        }
    };

    const fetchLedgerData = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.post(
                `${BASE_URL}/ledger/filter-ladger-by-name-and-member`,
                null,
                {
                    params: {
                        unitNO: unitNo,
                        memberName: memberName,
                        societyName: societyName,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("Ledger Response:", response.data);
            setLedgerList(response.data);
        } catch (error) {
            console.error("Error fetching ledger data:", error);

            if (error.response) {
                console.log("Status:", error.response.status);
                console.log("Data:", error.response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-container">
            <Header />
            <div className="main-layout">
                <Sidebar />
                <main className="content-area">
                    <SubHeader />
                    <div className="container mt-4">
                        <div className="card">
                            <div className="card-header">
                                <h4>Ledger Details</h4>
                            </div>
                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label><b>Member Name</b></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={memberName}
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label><b>Unit Number</b></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={unitNo}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <hr />

                                <h5>Ledger Records</h5>

                                {loading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Sr No</th>
                                                <th>Ledger Date</th>
                                                <th>VCH Type</th>
                                                <th>Debit</th>
                                                <th>Credit</th>
                                                <th>Balance</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {ledgerList.length > 0 ? (
                                                ledgerList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.ledgerDate}</td>
                                                        <td>{item.vchType}</td>
                                                        <td>{item.debit}</td>
                                                        <td>{item.credit}</td>
                                                        <td>{item.balance}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => {
                                                                    setEditData(item);
                                                                    setShowModal(true);
                                                                }}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                    {showModal && (
                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">

                                    <div className="modal-header">
                                        <h5 className="modal-title">Edit Ledger</h5>

                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowModal(false)}
                                        ></button>
                                    </div>

                                    <div className="modal-body">

                                        <div className="row">

                                            <div className="col-md-6 mb-3">
                                                <label>Ledger Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={editData.ledgerDate || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            ledgerDate: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Particular</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.particular || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            particular: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>VCH Type</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.vchType || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            vchType: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Debit</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.debit || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            debit: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Credit</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.credit || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            credit: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Balance</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.balance || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            balance: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Society Name</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.societyName || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            societyName: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Flat No</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.flatNo || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            flatNo: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Member Name</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.memberName || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            memberName: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Instrument</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.instrument || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            instrument: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Instrument No</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.instrumentNo || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            instrumentNo: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Bill / Receipt No</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.numberBillOrReceipt || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            numberBillOrReceipt: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label>Advance Payment</label>
                                                <input
                                                    className="form-control"
                                                    value={editData.advancePayment || ""}
                                                    onChange={(e) =>
                                                        setEditData({
                                                            ...editData,
                                                            advancePayment: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>

                                        </div>

                                    </div>

                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>

                                        <button
                                            className="btn btn-success"
                                            onClick={handleUpdate}
                                        >
                                            Update
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default LadgerDetails;